const API_HOST = process.env.REACT_APP_API_HOST;

export const MATKA_REPORT_ENDPOINTS = {
  byMarket: "/reports/by-market",
  byMatch: "/reports/by-match",
  byUser: "/reports/by-user",
  overview: "/reports/overview",
  export: "/reports/export",
};

const authHeaders = () => ({
  "Content-Type": "application/json",
  Authorization: "Bearer " + localStorage.getItem("jwt"),
});

export const fetchMatkaReportPage = async (endpoint, payload) => {
  const response = await fetch(`${API_HOST}${endpoint}`, {
    method: "POST",
    headers: authHeaders(),
    body: JSON.stringify(payload),
  });

  if (response.status === 401) {
    throw new Error("Unauthorized");
  }

  const result = await response.json();
  if (!result?.success) {
    throw new Error(result?.message || "Failed to fetch report data");
  }

  return result.data;
};

export const fetchMatkaReportOverview = (payload) =>
  fetchMatkaReportPage(MATKA_REPORT_ENDPOINTS.overview, payload);

export const fetchMatkaReportExport = (payload) =>
  fetchMatkaReportPage(MATKA_REPORT_ENDPOINTS.export, payload);

export const createMatkaReportDatasource = ({
  endpoint,
  getBasePayload,
  getSearch,
  onMeta,
}) => ({
  getRows: async (params) => {
    try {
      const pageSize = params.endRow - params.startRow;
      const page = Math.floor(params.startRow / pageSize) + 1;
      const sortModel = params.sortModel?.[0];

      const data = await fetchMatkaReportPage(endpoint, {
        ...getBasePayload(),
        page,
        pageSize,
        search: getSearch?.() || "",
        sortField: sortModel?.colId || "",
        sortOrder: sortModel?.sort || "desc",
      });

      onMeta?.(data);
      params.successCallback(data.rows || [], data.pagination?.totalRows ?? 0);
    } catch (error) {
      console.error("Matka report datasource error:", error);
      params.failCallback();
    }
  },
});

export { slNoColumn, formatDrawDate } from "./jodiReportServerSide";
